module.exports = __webpack_public_path__ + "static/img/img_1.293069f3.png";